export default "__VITE_ASSET__CnETppu9__"